import React from "react";
import {SubscribeForm} from "./SubscribeForm";

import {useACFOptions} from "../_hooks/useACFOptions";

export const Subscribe = ({number, color = 'pink'}) => {
  number = number || '04.';

  const { subscribe } = useACFOptions();

  const {suptitle, title, text} = subscribe;

  return (
    <section className="home-subscribe pt-lg-16 pb-lg-16 py-md-11 py-11">
      <div className="container">
        <div className="py-lg-7 px-lg-4 p-md-5 px-4 py-6 border border-1 rounded-5">
          <div className="row align-items-xl-center align-items-md-end">
            <div className="col-xl-6 col-lg-6 col-md-7 d-xl-flex">
              <div className='me-4'>
                <span className={`zg-label bg-${color} text-black me-2 mb-2 d-inline-block`}>{number}</span>
                <span className={`zg-label bg-${color} text-black mb-2 d-inline-block`}>{suptitle}</span>
              </div>
              {title && (
                <h2 className="h3 mb-5 mb-md-6 mt-3 my-lg-0 letter-spacing-4 mt-lg-4 mt-xl-0">{title}</h2>
              )}
            </div>
            <div className="col-xl-2 col-lg-6 col-md-4">
              {text && (
                <p className="fs-7 mb-xl-0 mb-lg-4 mb-5">{text}</p>
              )}
            </div>
            <div className="col-xl-4 col-lg-6 offset-lg-6 offset-xl-0">
              <SubscribeForm/>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
